<div class="rounded-md border overflow-hidden">
	<div class="relative">
		<div class="img-wrapper">
			<img [src]="locationStreetViewUrl" />
		</div>
	</div>
</div>
